var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotateCanvas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000621573 16.0497L3.3378 16L3.3417 18.5035C3.32776 18.8782 3.44261 19.0468 3.64719 19.012L6.06627 19.0024C6.1503 19.7295 6.37395 20.0102 6.80066 20.0124H17.2415C17.6422 20.0221 17.9514 19.8216 17.9873 19.0308H20.2246C20.5507 19.0131 20.638 18.7787 20.6332 18.3756V16.0039L23.9791 16.0217L23.9985 22.3882C24.0208 23.1098 23.7982 23.4688 23.3543 23.5L0.647202 23.4952C0.194086 23.4808 0.00477786 23.2226 0.01749 22.513C0.0262638 20.4872 -0.00288474 16.4628 0.000234818 16.0507L0.000621573 16.0497Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C17.78 0 24 1.84097 24 5.8834C24 9.46105 19.1275 11.3132 14 11.6919V15L8.1855 10.1622L14 5.32448V8.47638C18.6005 8.09824 21 6.48832 21 5.8834C21 5.19611 17.9055 3.20913 12 3.20913C6.0945 3.20913 3 5.19611 3 5.8834C3 6.17918 3.7895 7.06597 6.136 7.77572L6.5 7.88536V11.1876L5.88 11.0234C2.0885 10.02 0 8.19451 0 5.8834C0 1.84097 6.22 0 12 0Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateCanvas);
export default __webpack_public_path__ + "static/media/RotateCanvas.f6a310e11e534d2cdda635e15dfbf0d5.svg";
export { ForwardRef as ReactComponent };